import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';

export const TABLE_PAGE_INIT = '1';
export const TABLE_PAGE_SIZE = '10';

export const DATA_SETTING = {
  username: 'cash_register_camera',
  roleType: 'coOwner',
};

export const DatePattern = {
  DATE: 'YYYY-MM-DD',
  DATE_JP: 'YYYY年MM月DD日',
  TIME: 'HH:mm:ss',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  MONTH_DATE: 'MM-DD',
  UTC_DATE: 'YYYY-MM-DD[T]HH:mm:ss',
};

export const convertDateUTCToLocal = (
  utcString: string,
  format = DatePattern.DATE
) => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return dayjs.utc(utcString).tz(clientTimeZone).format(format);
};

export const saveKeyToLocalStorage = (storageKey: string, value: string) => {
  const encrypted = CryptoJS.AES.encrypt(
    value,
    process.env.REACT_APP_SECRET_KEY ?? ''
  ).toString();
  localStorage.setItem(storageKey, encrypted);
};

export const getKeyFromLocalStorage = (storageKey: string): string => {
  const encrypted = localStorage.getItem(storageKey);
  if (!encrypted) return '';

  try {
    const bytes = CryptoJS.AES.decrypt(
      encrypted,
      process.env.REACT_APP_SECRET_KEY ?? ''
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Decoding failed', e);
    return '';
  }
};

export const removeKeyFromLocalStorage = (storageKeys: string[]) => {
  storageKeys.forEach((storageKey) => localStorage.removeItem(storageKey));
};

export const generateUuid = () => {
  let username = getKeyFromLocalStorage('username');
  if (!username) {
    username = uuidv4();
    saveKeyToLocalStorage('username', username);
  }
  return username;
};
